/*
 *
 * Authorization API
 *
 */

export { makeRequest, clear } from './actions';
export { NAMESPACE } from './constants';
export { default as reducer } from './reducer';



// WEBPACK FOOTER //
// ./src/services/LoginType/index.js